var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "32X32/Top_bar/logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 20.6272V22.8984C19 23.5008 18.7366 24.0785 18.2678 24.5044C17.7989 24.9303 17.163 25.1696 16.5 25.1696H6.5C5.83696 25.1696 5.20107 24.9303 4.73223 24.5044C4.26339 24.0785 4 23.5008 4 22.8984V9.2712C4 8.66884 4.26339 8.09115 4.73223 7.66522C5.20107 7.23929 5.83696 7 6.5 7H16C17.3806 7 19 8.01693 19 9.2712V11.5424M23 20.6272L28 16.0848L23 11.5424M11 16.0848H27",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.628798db22b3595bd9738836f7233f7f.svg";
export { ForwardRef as ReactComponent };